import { jsx as n } from "react/jsx-runtime";
import { forwardRef as l } from "react";
import c from "./server-component.mjs";
const p = l(
  ({ story: e, ...r }, o) => {
    if (!e)
      return console.error(
        "Please provide a 'story' property to the StoryblokServerStory"
      ), null;
    if (globalThis != null && globalThis.storyCache.has(e.uuid) && (e = globalThis.storyCache.get(e.uuid), globalThis.storyCache.delete(e.uuid)), typeof e.content == "string")
      try {
        e.content = JSON.parse(e.content);
      } catch (t) {
        console.error(
          "An error occurred while trying to parse the story content",
          t
        ), e.content = {};
      }
    return /* @__PURE__ */ n(c, { ref: o, blok: e.content, ...r });
  }
);
export {
  p as default
};
